import { IconFeatureCard } from "@repo/ui/components/common/cms";
import type { IconFeatureCard as IconFeatureCardType } from "@repo/ui/types/cms";

interface FeaturesProps {
  features: IconFeatureCardType[];
}

export function Features({ features }: Readonly<FeaturesProps>) {
  return (
    <div className="hidden md:flex container mx-auto" data-testid="destinations-features-section">
      <div className="grid grid-cols-3 mx-16 mb-8" data-testid="destinations-features-grid">
        {features.length > 0 &&
          features.map((item: IconFeatureCardType) => (
            <IconFeatureCard
              key={item.title}
              item={item}
              testId={`destinations-feature-${item.title}-card`}
            />
          ))}
      </div>
    </div>
  );
}
